export class JobProgressStepNetworkInterfaceCreationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "networkInterfaceId",
            "baseName": "networkInterfaceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetId",
            "baseName": "subnetId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountName",
            "baseName": "accountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "consoleUrl",
            "baseName": "consoleUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepNetworkInterfaceCreationData.attributeTypeMap;
    }
    constructor() {
    }
}
